export const requestServiceOnRollOffData = [
  {
    Question: `How do I request service on a roll-off dumpster?`,
    Answer: `<strong>If you're an existing roll-off customer, you may request service online or through the Mobile App.</strong> 

        1. Click on the <strong>My WM</strong> icon located in the top-right corner of the wm.com homepage 
        
        2. Locate your service by entering one of the following: service address, service phone, service email, or <strong>Customer ID</strong> 
        
        3. Click Manage My Services 
        
        4. Under <strong>What Can I Request</strong>, Click <strong>Remove</strong> 
        
        5. Complete all required fields on the form 
        
        6. <strong>Submit</strong> your request 
        
        <strong>Note:</strong> Your roll-off dumpster should only be filled to the fill line/top of the dumpster. The driver needs to safely secure the load with a tarp for transportation. If the dumpster is filled over the top and we are unable to cover it, we will not be able to service the dumpster, which may require an additional charge. Ensure there are no objects blocking the roll-off dumpster. 
        
          
        
        For questions or concerns about common obstructions, please Link insertion: <a href=’https://www.wm.com/us/en/support#support’>Contact Us.</a>" `,
  },
]
